import { proxy } from "valtio";

export const cartingStore = proxy({
    current:{},
    disable:false,
    update:false,
    validation:{
        "portOfReceipt": true,
        "portOfLoading": true,
        "portOfDischarge": true,
        "finalPlaceOfDelivery": true,
        "reworkingPort":true
    },
    setValidation:()=>{
        let k = Object.keys(cartingStore.validation)
        for (let i = 0; i < k.length; i++) {
            cartingStore.validation[k[i]] = true
        }
    },
    new: {
    "general": false,
    "refer": false,
    "ODC": false,
    "palletization": false,
    "none": false,
    "commercialInvoice_filename_list":[],
    "packingList_filename_list":[],
    "shippingBill_filename_list":[],
    "cartingPhotos_filename_list":[],
    "shippingBillchecklist_filename_list":[],
    "mmSlip_filename_list":[],
    },
    list:{
    "bankInvolved":false,
    "nomination":false,
    "itp":false,
    "mode": "",
    "invoiceDetails": [],
    "cargoDetails": [],
    "cargoDimensionUnit": "",
    "hazardous": true,
    "nonStackable":false,
    "shipperName": "",
    "shippingBillNo": "",
    "shippingBillDate": "",
    "IECCode": "",
    "address": "",
    "LeoDateTime": "",
    "consigneeName": "",
    "consigneeAddress": "",
    "CHAName": "",
    "CHANumber": "",
    "entityId": "",
    "SHEDLocation": "",
    "eta_at_pol": "",
    "remarks_special_instrctions": "",
    "quoteClass": "",
    "unnumber": "",
    "portOfReceipt": "",
    "portOfLoading": "",
    "portOfDischarge": "",
    "finalPlaceOfDelivery": "",
    "reefer": false,
    "totalWeight":"",
    "totalNumPackages":"",
    "totalVolume":"",
    "salesperson":"",
    "customerService":"",
    "overHeight": false,
    "overlength": false,
    "topLoading": false,
    "fumigation": false,
    "headLoad": false,
    "doorLoad": false,
    "netWeight":0,
    "CFSLocation":"",
    "reworkingPort":"",
    "overHeightValue":"",
    "overlengthValue":""
},
requiredlist:{
    "shipperName": "",
    "shippingBillNo": "",
    "shippingBillDate": "",
    "address": "",
    "consigneeName": "",
    "consigneeAddress": "",
    "CHAName": "",
    "CHANumber": "",
    "portOfReceipt": "",
    "portOfLoading": "",
    "portOfDischarge": "",
    "reworkingPort":"",
    "finalPlaceOfDelivery": "",
    "netWeight":0,
    "CFSLocation":""
},
schedule:{
    por:"",
    pol:"",
    pod:"",
    fpod:"",
    cutoffpor:"",
    etdpol:"",
    etapod:"",
    etafpod:"",
    vesselname:"",
    voyage:"",
    carrier:"",
    transittime:"",
    coloader:"",
    stuffing_cutoff:""
},
setSchedule:()=>{
    let data = cartingStore.current
    let s = cartingStore.schedule
    s.por=data.portOfReceipt
    s.pol=data.portOfLoading
    s.pod=data.portOfDischarge
    s.fpod=data.finalPlaceOfDelivery
    s.rep=data.reworkingPort
    s.cutoffpor=""
    s.etdpol=""
    s.etapod=""
    s.etafpod=""
    s.vesselname=""
    s.voyage=""
    s.carrier=""
    s.transittime=""
    s.coloader=""
    s.stuffing_cutoff=""
},
setSchedulecreatebooking:(data)=>{
    let s = cartingStore.schedule
    s.por=data.portOfReceipt
    s.pol=data.portOfLoading
    s.pod=data.portOfDischarge
    s.fpod=data.finalPlaceOfDelivery
    s.rep=data.reworkingPort
    s.cutoffpor=""
    s.etdpol=""
    s.etapod=""
    s.etafpod=""
    s.vesselname=""
    s.voyage=""
    s.carrier=""
    s.transittime=""
    s.coloader=""
    s.stuffing_cutoff=""
}
})